import type { ProgramPublicProfile } from '@/mocks/programProfile';

interface Props {
  profile: ProgramPublicProfile;
}

export default function ProgramDescriptionSection({ profile }: Props) {
  return (
    <section className="bg-background-50 rounded-2xl border border-background-200/70 p-5 md:p-6">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
          <i className="ri-information-line text-accent-600 text-sm"></i>
        </div>
        <h2 className="text-base font-bold text-foreground-950">Sobre el programa</h2>
      </div>
      <p className="text-sm text-foreground-600 leading-relaxed">{profile.description}</p>

      {/* Tags */}
      <div className="flex items-center gap-1.5 flex-wrap mt-4">
        {profile.tags.map((tag) => (
          <span key={tag} className="px-2.5 py-0.5 rounded-lg bg-secondary-100 text-secondary-700 text-[11px] font-medium">
            #{tag}
          </span>
        ))}
      </div>
    </section>
  );
}